import { render, staticRenderFns } from "./SkinToneModal.vue?vue&type=template&id=194a1491"
import script from "./SkinToneModal.vue?vue&type=script&lang=js"
export * from "./SkinToneModal.vue?vue&type=script&lang=js"
import style0 from "./SkinToneModal.vue?vue&type=style&index=0&id=194a1491&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports